<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VCOkiM/tc-custom/9780253005687.jpg?1726617311331" alt="This image is the cover for the book Storytelling on the Northern Irish Border"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Storytelling on the Northern Irish Border
      </h1>
      <p class="bookDescription body article font2">
        <b>A folklorist explores the storytelling traditions of a small Irish town where local character anecdotes build community across sectarian divides.</b><br/><br/>More than quaint local color, folklore is a crucial part of life in Aghyaran, a mixed Catholic-Protestant border community in Northern Ireland. Neighbors socialize during wakes and ceilis—informal nighttime gatherings—without regard to religious, ethnic, or political affiliation. The witty, sometimes raucous stories swapped on these occasions offer a window into Aghyaran residents’ views of self and other in the wake of decades of violent conflict.<br/><br/>Through anecdotes about local characters, participants explore the nature of community and identity in ways that transcend Catholic or Protestant sectarian histories. Ray Cashman analyzes local character anecdotes in detail and argues that while politicians may take credit for the peace process in Northern Ireland, no political progress would be possible without ordinary people using shared resources of storytelling and socializing to imagine and maintain community.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ray Cashman
      </h2>
      
      <p class="authorDescription body article"><P>Ray Cashman is Associate Professor in the Department of English and the Center for Folklore Studies at Ohio State University.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?568f13d6